import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { AssignmentScheduleStateService } from '../../services/assignment-schedule-state.service';
import { AssignmentScheduleOptionAnswerEnum } from '../../enums/assignment-schedule-option-answer.enum';

@Component({
    selector: 'app-assignment-schedule-answer-overview',
    templateUrl: './assignment-schedule-answer-overview.component.html',
    styleUrl: './assignment-schedule-answer-overview.component.scss'
})
export class AssignmentScheduleAnswerOverviewComponent {

    protected assignmentScheduleStateService = inject(AssignmentScheduleStateService);


    protected get yesCount(): number | null {
        return this.getCount(AssignmentScheduleOptionAnswerEnum.yes);
    }

    protected get maybeCount(): number | null {
        return this.getCount(AssignmentScheduleOptionAnswerEnum.maybe);
    }

    protected get noCount(): number | null {
        return this.getCount(AssignmentScheduleOptionAnswerEnum.no);
    }

    protected get notAnsweredCount(): number | null {
        return this.getCount(null);
    }

    private getCount(answer: AssignmentScheduleOptionAnswerEnum | null): number | null {
        const val = this.assignmentScheduleStateService.assignmentScheduleDetailsSubject.value;
        if (val == null) return null;
        return val.options.filter(x => x.answer == answer).length;
    }

}
